<crm-single-select
  [options]="taskTypes"
  [(selectedItem)]="selectedTaskType"
  (selectedItemChange)="selectedTaskTypeChange.emit($event)"
  (changeValue)="changeValue.emit($event)"
  [showClear]="showClear"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [appendTo]="appendTo"
  [disabled]="disabled"
  [loading]="loading || internalLoading">
</crm-single-select>
